// Angular
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-hero-carousel-error',
  standalone: true,
  imports: [],
  templateUrl: './hero-carousel-error.component.html',
  styleUrl: './hero-carousel-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroCarouselErrorComponent {
  @Input({ required: true }) error!: string;
  @Output() retry = new EventEmitter<void>();

  onRetry(): void {
    this.retry.emit();
  }
}
